import Product from "./Product";
import QuickAdd from '../global/QuickAdd';

export default class FeaturedProduct extends Product {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad, true);

    this.loadQuickAdd();
  }

  loadQuickAdd = () => {
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
  }
}
